import { render } from "./inputMs.vue?vue&type=template&id=2f6b81d6"
import script from "./inputMs.vue?vue&type=script&lang=js"
export * from "./inputMs.vue?vue&type=script&lang=js"

import "./inputMs.vue?vue&type=style&index=0&id=2f6b81d6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__